import type { PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';
import { FontLineHeightNormal, Spacing8, Spacing16 } from 'autogen/design-tokens/tokens';
import { verticalEllipsis } from 'modules/helpers/mixins';
import useGA4Tracking from 'modules/tracking/GA4/GA4Tracking';
import ToggleReadMoreButton from './ToggleReadMoreButton';

type Accordion = PropsWithChildren & {
    previewLines: number;
    collapsed: boolean;
    setCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
};

const AccordionContent = styled.div<{ $previewLines: number; $collapsed: boolean }>`
    line-height: ${FontLineHeightNormal}rem;
    min-height: ${({ $previewLines }) => $previewLines * FontLineHeightNormal}rem;

    ${({ $collapsed, $previewLines }) =>
        $collapsed &&
        css`
            ${verticalEllipsis($previewLines)}
            height: ${$previewLines * FontLineHeightNormal}rem;
        `}
`;

const StyledToggleReadMoreButton = styled(ToggleReadMoreButton)`
    margin-top: ${Spacing16};
    margin-bottom: ${Spacing8};
`;

export default function Accordion(props: Accordion) {
    const { children, collapsed, setCollapsed, previewLines } = props;
    const GA4Tracking = useGA4Tracking();

    function tracking() {
        GA4Tracking({
            eventName: 'read_more',
            category: 'ecommerce',
            eventParams: [{ param_name: 'toggle', param_value: collapsed }]
        });
    }

    return (
        <>
            <AccordionContent $collapsed={collapsed} $previewLines={previewLines}>
                {children}
            </AccordionContent>
            <StyledToggleReadMoreButton
                collapsed={collapsed}
                onClickCallback={() => {
                    setCollapsed(!collapsed);
                    tracking();
                }}
            />
        </>
    );
}
